import React from 'react';
import {FC, Fragment} from 'react';
import {toastConfig} from './constants';
import messages from './messages';
import Button from 'components/button';
import {actions} from 'features/listing/list/slice';
import {useRestoreResourceMutation} from 'features/listing/list/slice/restore-resource';
import {Trans, useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import {toast} from 'react-toastify';
import {ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import {ResourceName} from 'types/resource-name';

const ReincarnationAngel: FC<Props> = props => {
  const {message, onDismiss} = props;

  const {t} = useTranslation();

  const [execute, {isLoading}] = useRestoreResourceMutation();

  const dispatch = useDispatch();

  const handleRestoreResource = async (acc: boolean) => {
    if (!acc) {
      onDismiss();
      return;
    }
    const result = await execute({
      name: props.name,
      resourceId: props.resourceId,
      otherParams: props.otherParams,
    });
    if ('data' in result) {
      dispatch(
        actions.restoreResource({
          resource: result.data.data,
          resourceName: props.name,
        })
      );
      toast.success(result.data.message, toastConfig);
    }

    onDismiss();
  };

  return (
    <Fragment>
      <ModalHeader className="bg-primary" toggle={onDismiss}>
        <span className="text-light">
          <Trans i18nKey={messages.alert()} />
        </span>
      </ModalHeader>
      <ModalBody className="">
        <p>{message ?? <Trans i18nKey={messages.restoreConfirmation()} />}</p>
      </ModalBody>
      <ModalFooter>
        <Button
          color="important"
          onClick={() => handleRestoreResource(true)}
          isLoading={isLoading}
        >
          {t(...messages.yesImSure())}
        </Button>
        <Button color="secondary" onClick={() => handleRestoreResource(false)}>
          {t(...messages.cancel())}
        </Button>
      </ModalFooter>
    </Fragment>
  );
};

interface Props {
  message?: string;
  name: ResourceName;
  onDismiss: () => void;
  otherParams?: any;
  resourceId: string | number;
}

export default ReincarnationAngel;
